import { useState } from "react";
import { Trans } from "react-i18next";
import i18next from "i18next";

import { Callout, FormGroup } from "@blueprintjs/core";
import { DateInput3 } from "@blueprintjs/datetime2";

import DB from "./DB";
import Matchings from "./Matchings";
import Detections from "./Detections";
import Countries from "./Countries";
import VehicleClasses from "./VehicleClasses";
import ClassificationReliability from "./Classification";

export default function Performances(props) {
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  return (
    <Callout icon="chart" title="Performances">
      <div className="flexbox-left">
        <FormGroup label={<Trans>from</Trans>} labelFor="from" inline={true}>
          <DateInput3
            id="from"
            formatDate={(date) =>
              new Date(date).toLocaleString(i18next.language)
            }
            onChange={(date) => setFrom(new Date(date).toISOString())}
            parseDate={(str) => new Date(str)}
            highlightCurrentDay={true}
            timePrecision="minute"
            showTimezoneSelect={false}
            showActionsBar={true}
            todayButtonText={<Trans>today</Trans>}
            clearButtonText={<Trans>clear</Trans>}
          />
        </FormGroup>

        <FormGroup label={<Trans>to</Trans>} labelFor="to" inline={true}>
          <DateInput3
            id="to"
            formatDate={(date) =>
              new Date(date).toLocaleString(i18next.language)
            }
            onChange={(date) => setTo(new Date(date).toISOString())}
            parseDate={(str) => new Date(str)}
            highlightCurrentDay={true}
            timePrecision="minute"
            showTimezoneSelect={false}
            showActionsBar={true}
            todayButtonText={<Trans>today</Trans>}
            clearButtonText={<Trans>clear</Trans>}
          />
        </FormGroup>
      </div>
      <Matchings srv={props.srv} from={from} to={to} />
      <br />
      <Detections srv={props.srv} from={from} to={to} />
      <br />
      <Countries srv={props.srv} from={from} to={to} />
      <br />
      <VehicleClasses srv={props.srv} from={from} to={to} />
      <br />
      <ClassificationReliability srv={props.srv} from={from} to={to} />
      <br />
      <DB srv={props.srv} from={from} to={to} />
    </Callout>
  );
}
